import initialStates from './initialState'
import { encyptedData } from '../views/Access'

const GlobalReducer = (state, { type, payload }) => {
  switch (type) {
    case 'PROFILE':
      localStorage.setItem('USERDATA', encyptedData(payload))
      localStorage.setItem('USERTOKEN', encyptedData(payload.userToken))
      return {
        ...state,
        isAuthenticated: true,
        userType: payload.role,
        userId: payload._id,
        userName: payload.username,
        firstName: payload.firstName,
        lastName: payload.lastName,
        officialEmail: payload.email,
        createdBy: payload.createdBy,
        countryList: payload.countryList || state.countryList || [],
        companyName: payload?.userProfile?.companyName || payload?.UserProfile?.companyName || state.companyName,
        designation: payload?.UserProfile?.designation || payload?.userProfile?.designation || state.designation
      }
    case 'MEMBER_TYPE':
      localStorage.setItem('memberType', payload.memberType)
      return {
        ...state,
        memberTypes: payload.memberType,
      }
    case 'PDF_VIEWER':
      console.log(payload)
     return {
      ...state,
      pdfData: payload,
     }
    case 'SET_RFQ_COUNTS':
      return {
        ...state,
        rfqCounts: payload,
      }
    case 'INCREMENT_RFQ_REFRESH':
      return {
        ...state,
        rfqCountRefreshKey: (state.rfqCountRefreshKey || 0) + 1,
      }
    case 'SET_PRIVILEGES':
      return { ...state, menuPrivileges: payload }
    case 'LOGOUT':
      localStorage.clear()
      return initialStates
    default:
      return state
  }
}
export default GlobalReducer
